<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<fab-loading-spinner [hidden]="(!showSpinner)" color="primary"></fab-loading-spinner>
<div id="header-container">
  <h3 id="header-text">GM Market Share of Segment Report</h3>
  <div>
    <button color="primary" class="run-report-button"
            id="run-report-button"
            [disabled]="selectedGeography === undefined || !(scenarioYearRange.length > 0) ||
                    (!selectedCompareGlblScenRow && isIncludeCompareScenario && selectedScenarioType === 'global') ||
                    selectedStartYear > selectedEndYear"
            (click)="onRunReport()"
            mat-raised-button>
      Run Report
    </button>
  </div>
</div>
<div id="main-content" class="d-flex gap-16 align-content-between">
  <!-- Filter Dropdowns -->
  <div id="filters" class="filter-container d-flex flex-column gap-8">
    <h3>Filter By:</h3>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label [ngClass]="{'disabled-text': !(selectedVehScenRow || selectedGlblScenRow)}">Region</mat-label>
      <fab-multiselect
        name="regionFilter"
        [(ngModel)]="regionOptions.selectedOptions"
        (ngModelChange)="onFilterChange(REGION)"
        [options]="regionOptions.options"
        [disabled]="!(selectedVehScenRow || selectedGlblScenRow)">
      </fab-multiselect>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label [ngClass]="{'disabled-text': !(selectedVehScenRow || selectedGlblScenRow)}">Subregion</mat-label>
      <fab-multiselect
        name="subregionFilter"
        [(ngModel)]="subregionOptions.selectedOptions"
        (ngModelChange)="onFilterChange(SUBREGION)"
        [options]="subregionOptions.options"
        [disabled]="!(selectedVehScenRow || selectedGlblScenRow)">
      </fab-multiselect>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label [ngClass]="{'disabled-text': !(selectedVehScenRow || selectedGlblScenRow)}">Planning Market</mat-label>
      <fab-multiselect
        name="plngMktFilter"
        [(ngModel)]="plngMktOptions.selectedOptions"
        (ngModelChange)="onFilterChange(PLNGMKT)"
        [options]="plngMktOptions.options"
        [disabled]="!(selectedVehScenRow || selectedGlblScenRow)">
      </fab-multiselect>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label [ngClass]="{'disabled-text': !(selectedVehScenRow || selectedGlblScenRow)}">Architecture</mat-label>
      <fab-multiselect
        name="archFilter"
        [(ngModel)]="archOptions.selectedOptions"
        (ngModelChange)="onFilterChange(ARCH)"
        [options]="archOptions.options"
        [disabled]="!(selectedVehScenRow || selectedGlblScenRow)">
      </fab-multiselect>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label [ngClass]="{'disabled-text': !(selectedVehScenRow || selectedGlblScenRow)}">Market Division</mat-label>
      <fab-multiselect
        name="mktDivFilter"
        [(ngModel)]="mktDivOptions.selectedOptions"
        (ngModelChange)="onFilterChange(MKTDIV)"
        [options]="mktDivOptions.options"
        [disabled]="!(selectedVehScenRow || selectedGlblScenRow)">
      </fab-multiselect>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label [ngClass]="{'disabled-text': !(selectedVehScenRow || selectedGlblScenRow)}">Local Brand</mat-label>
      <fab-multiselect
        name="localBrandFilter"
        [(ngModel)]="lbrandOptions.selectedOptions"
        (ngModelChange)="onFilterChange(LBRAND)"
        [options]="lbrandOptions.options"
        [disabled]="!(selectedVehScenRow || selectedGlblScenRow)">
      </fab-multiselect>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label [ngClass]="{'disabled-text': !(selectedVehScenRow || selectedGlblScenRow)}">Program Code</mat-label>
      <fab-multiselect
        name="prgmCodeFilter"
        [(ngModel)]="prgmCodeOptions.selectedOptions"
        (ngModelChange)="onFilterChange(PRGMCODE)"
        [options]="prgmCodeOptions.options"
        [disabled]="!(selectedVehScenRow || selectedGlblScenRow)">
      </fab-multiselect>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label [ngClass]="{'disabled-text': !(selectedVehScenRow || selectedGlblScenRow)}">Type of Sale</mat-label>
      <fab-multiselect
        name="tosFilter"
        [(ngModel)]="tosOptions.selectedOptions"
        [options]="tosOptions.options"
        [disabled]="!(selectedVehScenRow || selectedGlblScenRow)">
      </fab-multiselect>
    </mat-form-field>
    <div class="d-flex gap-8 flex-row justify-content-center ">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label class="asterisk--before">Start Year</mat-label>
        <mat-select [(ngModel)]="selectedStartYear" [disabled]="!(selectedVehScenRow || selectedGlblScenRow) "
                    id="startYear">
          <mat-option *ngFor="let year of scenarioYearRange" [value]="year">{{ year }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label class="asterisk--before">End Year</mat-label>
        <mat-select [(ngModel)]="selectedEndYear" [disabled]="!(selectedVehScenRow || selectedGlblScenRow)"
                    id="endYear">
          <mat-option *ngFor="let year of scenarioYearRange" [value]="year">{{ year }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div id="scenario-content" class="d-flex flex-column gap-8 w-100">
    <!-- Scenario type toggle -->
    <div class="d-flex flex-column justify-content-center">
      <mat-button-toggle-group [(ngModel)]="selectedScenarioType"
                               hideSingleSelectionIndicator="true"
                               (ngModelChange)="resetVariables()">
        <mat-button-toggle id="forecast-org-toggle" [value]="'fcorg'" class="flex-grow-1">
          By Forecast Org
        </mat-button-toggle>
        <mat-button-toggle id="global-scenario-toggle" [value]="'global'" class="flex-grow-1">
          By Global Scenario
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <!-- Vehicle Scenario table with select -->
    <div id="scenario-container" class="d-flex w-100" *ngIf="selectedScenarioType === 'fcorg'">
      <table id="scenario-info-table" class="w-100">
        <tr>
          <td></td>
          <td class="working-scenario-content-border working-scenario-content-border-top column-header">
            <h2><b>Working Scenario</b></h2>
            <h3 *ngIf="!selectedVehScenRow" style="font-style: italic">Select Scenario
              Below</h3>
          </td>
          <td class="column-header">
            <h2 [ngClass]="{'disabled-text': !selectedVehScenRow}"><b>Compare Scenario</b></h2>
          </td>
        </tr>

        <!-- FORECAST ORG ROW -->
        <tr>
          <td class="scenario-labels">Forecast Organization</td>
          <td *ngIf="selectedVehScenRow" class="working-scenario-content-border">
            <div class="column-content">
              <span class="column-text">{{ selectedVehScenRow.fcorg }}</span>
            </div>
          </td>
          <td *ngIf="compareScenario">
            <div class="column-content">
              <span class="column-text">{{ compareScenario.fcorg }}</span>
            </div>
          </td>
          <!-- if no selected scenarios -->
          <td *ngIf="!selectedVehScenRow" class="working-scenario-content-border column-content"></td>
          <td *ngIf="!compareScenario"></td>
        </tr>

        <!-- VEHICLE SCENARIO ROW -->
        <tr class="light-gray-background">
          <td class="scenario-labels">Vehicle Scenario</td>
          <td *ngIf="selectedVehScenRow"
              class="working-scenario-content-border">
            <div class="column-content">
              <span class="column-text pad-left-50">{{ selectedVehScenRow.vehScenId }}
                - {{ selectedVehScenRow.vehScenName }}</span>
              <button mat-icon-button [matMenuTriggerFor]="vehicleMenu" class="vertical-dots"
                      matTooltip="More options">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #vehicleMenu="matMenu">
                <button mat-menu-item (click)="openSelectWorkingScen()" class="menu-width">
                  <mat-icon>autorenew</mat-icon>
                  <span>Change Scenario</span>
                </button>
              </mat-menu>
            </div>
          </td>
          <td *ngIf="compareScenario">
            <div class="column-content">
              <span class="column-text pad-left-50">{{ compareScenario.vehScenId }}
                - {{ compareScenario.vehScenName }}</span>
              <button mat-icon-button [matMenuTriggerFor]="compareVehicleMenu" class="vertical-dots"
                      matTooltip="More options">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #compareVehicleMenu="matMenu">
                <button mat-menu-item (click)="openSelectCompareScen()" class="menu-width">
                  <mat-icon>autorenew</mat-icon>
                  <span>Change Scenario</span>
                </button>
              </mat-menu>
            </div>
          </td>
          <!-- if no selected scenarios -->
          <td *ngIf="!selectedVehScenRow" class="working-scenario-content-border column-content">
          <span class="hyperlink"
                tabindex="0"
                (click)="openSelectWorkingScen()"
                (keydown.enter)="openSelectWorkingScen()">Select Vehicle Scenario</span>
          </td>
          <td *ngIf="!compareScenario"></td>
        </tr>

        <!-- INDUSTRY SCENARIO ROW -->
        <tr>
          <td class="scenario-labels">Industry Scenario</td>
          <td *ngIf="selectedVehScenRow"
              class="working-scenario-content-border working-scenario-content-border-bottom">
            <div class="column-content">
              <span class="column-text">{{ selectedVehScenRow.industryScenario.id }}
                - {{ selectedVehScenRow.industryScenario.industryScenarioName }}</span>
            </div>
          </td>
          <td *ngIf="compareScenario">
            <div class="column-content">
              <span class="column-text">{{ compareScenario.industryScenario.id }}
                - {{ compareScenario.industryScenario.industryScenarioName }}</span>
            </div>
          </td>
          <!-- if no selected scenarios -->
          <td *ngIf="!selectedVehScenRow"
              class="working-scenario-content-border working-scenario-content-border-bottom column-content"></td>
          <td *ngIf="!compareScenario"></td>
        </tr>

      </table>
    </div>
    <div *ngIf="selectedScenarioType === 'global'" class="content-height d-flex flex-column w-100 gap-8">

      <h3>Working Global Scenario</h3>
      <app-global-scenario-select-component
        class="h-100"
        [user]="stateService.getUserGmid()"
        [memberScenarioType]="0"
        [filterNonGM]="true"
        [displayedMemberColumns]="memberScenarioColumns"
        (confirmEvent)="onWorkingGlobalScenarioSelect($event)">
      </app-global-scenario-select-component>
    </div>
    <!-- Output By Dropdowns -->
    <div *ngIf="selectedVehScenRow || selectedGlblScenRow">
      <h3 id="output-by-text">Output By:</h3>
      <mat-form-field class="filter-options">
        <mat-label class="asterisk--before">Segment Level</mat-label>
        <mat-select [(ngModel)]="selectedSgmntLvl" id="sgmntLvlSelectList">
          <mat-option [value]="0">Total Vehicle</mat-option>
          <mat-option [value]="1">Global</mat-option>
          <mat-option [value]="2">Global Segment 2</mat-option>
          <mat-option [value]="3">Propulsion Segment</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="filter-options">
        <mat-label class="asterisk--before">Geography</mat-label>
        <mat-select [(ngModel)]="selectedGeography" id="geographySelectList">
          <mat-option *ngIf="selectedScenarioType === 'global' || selectedFcorgName === 'GMTVP'" value="GLOBAL">Global
          </mat-option>
          <mat-option [value]="REGION">Region</mat-option>
          <mat-option [value]="SUBREGION">Subregion</mat-option>
          <mat-option [value]="PLNGMKT">Planning Market</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="filter-options">
        <mat-label>Vehicle Details</mat-label>
        <fab-multiselect
          name="vehDetailFilter"
          [(ngModel)]="selectedVehDetails"
          [options]="vehDetailOptions">
        </fab-multiselect>
      </mat-form-field>
      <mat-checkbox [(ngModel)]="isIncludeTos"
                    [disabled]=false>
        Include Type of Sale
      </mat-checkbox>
      <mat-checkbox [(ngModel)]="isIncludeCompareScenario">
        <span>Include Compare Scenario</span>
      </mat-checkbox>
      <mat-checkbox *ngIf="selectedSgmntLvl === 3" [(ngModel)]="combinePhevIce">
        <span>Combine PHEV and ICE industry volumes</span>
      </mat-checkbox>
      <!-- compare global sen -->
      <div *ngIf="selectedScenarioType === 'global' && isIncludeCompareScenario"
           class="content-height d-flex flex-column w-100 gap-8">
        <h3>Compare Global Scenario</h3>
        <app-global-scenario-select-component
          class="h-100"
          [user]="stateService.getUserGmid()"
          [memberScenarioType]="0"
          [filterNonGM]="true"
          [displayedMemberColumns]="memberScenarioColumns"
          (confirmEvent)="onCompareGlobalScenarioSelect($event)">
        </app-global-scenario-select-component>
      </div>
    </div>
  </div>
</div>

